import type { DrawRecord, PickerEntry, PickscapeProject } from "../types";

function spreadsheetSafe(value: string): string {
  const normalized = value.replace(/\r\n/gu, "\n");
  if (/^[=+\-@\t\r\n\uFF1D\uFF0B\uFF0D\uFF20]/u.test(normalized)) {
    return `'${normalized}`;
  }
  return normalized;
}

function csvCell(value: string | number | boolean | null): string {
  const stringValue = spreadsheetSafe(String(value ?? ""));
  if (/[",\r\n]/u.test(stringValue)) {
    return `"${stringValue.replace(/"/gu, '""')}"`;
  }
  return stringValue;
}

export function entriesToCsv(entries: PickerEntry[]): string {
  const rows = [
    ["name", "category", "weight", "enabled"],
    ...entries.map((entry) => [entry.name, entry.category ?? "", entry.weight, entry.enabled]),
  ];
  return `\uFEFF${rows.map((row) => row.map(csvCell).join(",")).join("\r\n")}`;
}

export function historyToCsv(history: DrawRecord[]): string {
  const rows = [
    [
      "draw_number",
      "timestamp",
      "winner",
      "category",
      "weight",
      "eligible_count",
      "category_filter",
      "repeat_mode",
      "kept_in_pool",
      "stop_reason",
      "duration_ms",
    ],
    ...history.map((record) => [
      record.drawNumber,
      record.timestamp,
      record.winnerName,
      record.winnerCategory ?? "",
      record.winnerWeight,
      record.eligibleCount,
      record.categoryFilter.join(" | "),
      record.repeatMode,
      record.keptInPool,
      record.stopReason,
      record.durationMs,
    ]),
  ];
  return `\uFEFF${rows.map((row) => row.map(csvCell).join(",")).join("\r\n")}`;
}

export function projectToJson(project: PickscapeProject): string {
  return JSON.stringify(
    {
      ...project,
      schemaVersion: 1,
      exportedAt: new Date().toISOString(),
    },
    null,
    2,
  );
}

export function downloadText(content: string, fileName: string, type: string): void {
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = fileName;
  document.body.append(anchor);
  anchor.click();
  anchor.remove();
  URL.revokeObjectURL(url);
}
